function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.865,26.92C86.372,11.415,72.313,0,56.209,0C43.473,0,31.706,7.129,25.751,18.305 C11.174,19.887,0,32.186,0,47.052c0,15.947,12.974,28.921,28.921,28.921c0.154,0,0.305-0.004,0.457-0.009 c0.075,0.006,0.151,0.009,0.227,0.009h23.17V89.7c0,1.657,1.342,3,3,3c1.656,0,3-1.343,3-3V75.973h28.928 c0.16,0,0.316-0.013,0.468-0.037c13.136-0.652,23.372-11.381,23.372-24.581C111.542,38.873,102.022,28.392,89.865,26.92  M87.597,69.955c-0.08,0.003-0.158,0.009-0.236,0.018H58.774V41.846l5.873,5.873c1.172,1.173,3.071,1.174,4.244,0 c1.17-1.171,1.17-3.07,0-4.242L57.896,32.481c-0.857-0.858-2.147-1.115-3.27-0.65c-0.174,0.072-0.335,0.164-0.488,0.265 c-0.019,0.012-0.036,0.025-0.054,0.037c-0.139,0.096-0.269,0.202-0.389,0.318c-0.016,0.015-0.033,0.025-0.048,0.039L42.652,43.484 c-1.171,1.171-1.171,3.07,0,4.242c0.586,0.586,1.354,0.879,2.122,0.879c0.767,0,1.535-0.293,2.121-0.879l5.88-5.88v28.126H29.929 c-0.137-0.015-0.275-0.022-0.414-0.017l-0.196,0.007c-0.133,0.005-0.265,0.01-0.398,0.01C16.283,69.973,6,59.69,6,47.052 c0-12.258,9.583-22.313,21.817-22.892c1.112-0.053,2.104-0.717,2.575-1.726C35.065,12.451,45.199,6,56.209,6 C70.185,6,82.295,16.402,84.38,30.196c0.219,1.446,1.447,2.523,2.908,2.551c10.066,0.193,18.254,8.54,18.254,18.607 C105.542,61.428,97.659,69.599,87.597,69.955"
});

var SvgCarica = function SvgCarica(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 112,
    height: 94,
    viewBox: "-0.296 -0.529 112 94",
    enableBackground: "new -0.296 -0.529 112 94",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCarica, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carica.73c3b809.svg";
export { ForwardRef as ReactComponent };